import { generateVuexCrud, multipleEntityRequest } from '@/utilities/crud/vuex';

const crud = generateVuexCrud('productBan');

export const state = {
    ...crud.state,
};

export const actions = {
    ...crud.actions,

    storeProductBanEans(store, data) {
        return multipleEntityRequest('productBan', {
            method: 'post',
            url: `/api/productbans/eans`,
            data,
        });
    }
};

export const mutations = {
    ...crud.mutations,
};

